import React from 'react';
import classNames from 'classnames';
import useMediaQueries from '../../../hooks/useMediaQueries'
import { motion, AnimatePresence } from "framer-motion";
import styles from './Lights.module.scss';

function Lights({show, count}) {
    const { isLgMin } = useMediaQueries();

    return (
        <AnimatePresence>
            {show &&
                <motion.div 
                    className={styles.lights} 
                    initial={{y: isLgMin ? '-200%' : '200%', x: '-50%', scale: isLgMin ? 1 : .75}} 
                    animate={{y: 0, x: '-50%'}} 
                    exit={{y: isLgMin ? '-200%' : '200%', x: '-50%', transition: { delay: .5 }}
                    }>
                    <div className={classNames(styles.light, { [styles.isActive]: count >= 1 && count <= 5 })}></div>
                    <div className={classNames(styles.light, { [styles.isActive]: count >= 1 && count <= 4})}></div>
                    <div className={classNames(styles.light, { [styles.isActive]: count >= 1 && count <= 3})}></div>
                    <div className={classNames(styles.light, { [styles.isActive]: count >= 1 && count <= 2})}></div>
                    <div className={classNames(styles.light, { [styles.isActive]: count === 1})}></div>
                </motion.div>
            }
        </AnimatePresence>
    );
}

export default Lights;